import {
  BingoBlissRoute,
  BingoClashRoute,
  BingoTourRoute,
  BlockolotRoute,
  BubbleBuzzRoute,
  CashPoolRoute,
  DominoesRoute,
  DunkShotRoute,
  EightBallStrikeRoute,
  GamesRoute,
  MatchNFlipRoute,
  NumbersBlitzRoute,
  PlaySolitaireOnlineRoute,
  Pocket7GamesRoute,
  PoolClashRoute,
  SolitaireClashRoute,
  SolitaireInfiniteRoute,
  SolitaireSlamRoute,
  SolitaireVentureRoute,
  TileBlitzRoute,
  TwentyOneGoldRoute,
} from '../games'
import { generateMetadata } from './utils'

export const GamesMetaData = generateMetadata({
  title: 'AviaGames | Top Rated Fair Matching Skill Games',
  description:
    'Join top rated skill games with multiplayer tournaments on Avia! Play free or for cash, easy on hands, relax anytime.',
  keywords: ['skill games'],
  path: GamesRoute,
})

export const SolitaireClashMetaData = generateMetadata({
  title: 'Solitaire Clash | The Best Free Solitaire Game App',
  description:
    'Enjoy Solitaire Clash, the best free Solitaire game app! Download and play the classic solitaire with a competitive edge, win prizes, and have fun anytime, anywhere.',
  keywords: [
    'solitaire clash',
    'free solitaire',
    'how to play solitaire',
    'solitaire',
    'Klondike Solitaire',
    'classic solitaire',
  ],
  path: SolitaireClashRoute,
})

export const BingoClashMetaData = generateMetadata({
  title: 'Bingo Clash | The Ultimate Online Bingo for Cash Game',
  description:
    'Play Bingo Clash, the ultimate online bingo for cash game! Enjoy fast-paced, fun bingo gameplay, and win real cash rewards. Download now and start winning!',
  keywords: ['bingo clash', 'bingo for cash', 'bingo cash app', 'bingo app'],
  path: BingoClashRoute,
})

export const BingoTourMetaData = generateMetadata({
  title: 'Bingo Tour | Play Free Online Bingo & Win Real Cash',
  description:
    'Play Bingo Tour, the ultimate free online bingo game where you have the opportunity to win real cash! Enjoy fast-paced matches and exciting skill-based competition.',
  keywords: ['bingo tour', 'online bingo', 'free online bingo', 'bingo games online', 'play bingo online'],
  path: BingoTourRoute,
})

export const EightBallStrikeMetaData = generateMetadata({
  title: '8 Ball Strike | Free Pool Game | Play 8 Ball Pool & Win Real Cash',
  description:
    'Play 8 Ball Strike, a free 8 ball pool game where skill earns cash. Learn how to play 8 ball, compete online, and unlock custom cues for big wins!',
  keywords: ['how to play 8 ball', '8 ball game', '8 ball pool game', 'online 8 ball'],
  path: EightBallStrikeRoute,
})

export const SolitaireVentureMetaData = generateMetadata({
  title: 'Solitaire Venture | Play Online Solitaire for Cash',
  description:
    'Play solitaire for cash with Solitaire Venture! Build your island, compete in skill-based matches, and win real cash rewards. Download now and start your adventure!',
  keywords: [
    'classic solitaire card game',
    'solitaire for cash',
    'solitaire game',
    'classic solitaire',
    'Avia',
    'card games',
    'win real rewards',
  ],
  path: SolitaireVentureRoute,
})

export const Pocket7GamesMetaData = generateMetadata({
  title: 'Pocket7Games | Play Games That Pay Real Money',
  description:
    'Play exciting games that pay real money on Pocket7Games! Compete in skill-based tournaments, win cash prizes, and enjoy daily rewards. Start winning today!',
  keywords: [
    'pocket7games',
    'games that pay real money',
    'real money games app',
    'casual games',
    'skill games',
    'cash games',
    'real money games',
    'play games for real cash',
  ],
  path: Pocket7GamesRoute,
})

export const BlockolotMetaData = generateMetadata({
  title: 'Blockolot | Block Puzzle Game with Real Rewards',
  description:
    'Play Blockolot, the best block puzzle game that rewards puzzle-solving skills with real rewards. Clear blocks and score high in fun block puzzles online. ',
  keywords: [
    'blockolot',
    'block puzzle game',
    'block puzzle',
    'classic tetris',
    'free block games',
    'block puzzle online;',
  ],
  path: BlockolotRoute,
})

export const BubbleBuzzMetaData = generateMetadata({
  title: 'Bubble Buzz | Best Free Online Bubble Shooter Game',
  description:
    'Play Bubble Buzz, the best free bubble shooter online! Match, pop, and win real cash in fast-paced games with daily rewards and fun minigames.',
  keywords: ['free online bubble shooter game', 'free bubble shooter online', 'Bubble Buzz'],
  path: BubbleBuzzRoute,
})

export const CashPoolMetaData = generateMetadata({
  title: '8 Ball Strike | Cash Pool - Best Free 8 Ball Pool Game',
  description:
    'Download 8 Ball Strike: Cash Pool, the free 8 ball pool game where you can win real cash. Master how to play 8 ball, and unlock custom cues!',
  keywords: ['pool game', 'online pool', '8 Ball Online', '8 ball', 'billiards online', '8 pool'],
  path: CashPoolRoute,
})

export const SolitaireInfiniteMetaData = generateMetadata({
  title: 'Solitaire Infinite | Exciting Classic Solitaire Card Games',
  description:
    'Experience Solitaire Infinite, the ultimate classic solitaire game where you can compete in multiplayer tournaments to win real cash and prizes!',
  keywords: [
    'classic solitaire',
    'solitaire card games',
    'play solitaire',
    'card game',
    'solitaire clash',
    'real money',
    'win real money',
    'solitaire infinite',
    'solitaire setup',
    'real-money games',
  ],
  path: SolitaireInfiniteRoute,
})

export const SolitaireSlamMetaData = generateMetadata({
  title: 'Solitaire Slam | Level Up Your Solitaire Collection',
  description:
    'Level up your solitaire collection with Solitaire Slam—featuring fast-paced games, exciting tournaments, fun minigames, and secure cash matches.',
  keywords: [
    'solitaire collection',
    'classic solitaire game',
    'win real money ',
    'solitaire strategy',
    'best free solitaire',
    'solitaire games',
    'solitaire time',
  ],
  path: SolitaireSlamRoute,
})

export const BingoBlissMetaData = generateMetadata({
  title: 'Bingo Bliss | Play Bingo Game for Real Cash',
  description:
    'Play Bingo Bliss, the most exciting bingo game with cash prizes, power-ups, and thrilling matches! Enjoy free games or compete for real money. Download now!',
  keywords: ['bingo bliss', 'bingo game', 'bingo games', 'free bingo'],
  path: BingoBlissRoute,
})

export const MatchNFlipMetaData = generateMetadata({
  title: 'Play Uno Game Online For Fun | Match n Flip Card Game',
  description:
    'Play Match n Flip, a fast-paced Uno game online. Learn how to play Uno and enjoy fun, skill-based card games anytime with Pocket7Games.',
  keywords: ['uno game', 'uno game online', 'uno games', 'play uno', 'how to play uno'],
  path: MatchNFlipRoute,
})

export const PlaySolitaireOnlineMetaData = generateMetadata({
  title: 'Play Solitaire Online | Master the Traditional Solitaire Game',
  description:
    'Play Solitaire online and put your skills to the test! Enjoy free, fun, and challenging games anytime, perfect for players of all levels.',
  keywords: [
    'play solitaire online',
    'classic solitaire',
    'online solitaire',
    'card game',
    'card games to play',
    'solitaire game rules',
    'best solitaire app',
  ],
  path: PlaySolitaireOnlineRoute,
})

export const TwentyOneGoldMetaData = generateMetadata({
  title: '21 Gold | Master the Online Blackjack Games',
  description:
    '21 Gold is an exciting online blackjack-style 21-card game. Enjoy unique features, realistic graphics, and smooth gameplay for a thrilling experience every time you play!',
  keywords: [
    'blackjack',
    'blackjack strategy',
    'online blackjack',
    '21 card game',
    'pocket7games',
    'blackjack app',
    'card game',
    'play blackjack',
    'Blackjack rules',
    'Blackjack strategy',
    'Blackjack game',
  ],
  path: TwentyOneGoldRoute,
})

export const TileBlitzMetaData = generateMetadata({
  title: 'Tile Blitz | Play the Best Free Tetris Online Game',
  description:
    'Play Tile Blitz, the ultimate Tetris online game with vibrant graphics and exciting gameplay. Clear lines, score points, and compete for real cash prizes!',
  keywords: ['tile blitz', 'tetris online', 'block puzzle game', 'classic tetris', 'block puzzle'],
  path: TileBlitzRoute,
})

export const NumbersBlitzMetaData = generateMetadata({
  title: 'Play 2048 Online | The Best Number Puzzle Game',
  description:
    'Play 2048 online with 2048 Blitz! Slide tiles, merge into one, and challenge your skills in exciting number puzzle games to win real cash!',
  keywords: ['2048 online', '2048 game online', 'number puzzle'],
  path: NumbersBlitzRoute,
})

export const PoolClashMetaData = generateMetadata({
  title: 'Pool Clash | Play 8 Ball Online on Avia',
  description:
    'Play Pool Clash, the top 8 ball online pool game! Compete in fun billiards online matches—real prizes await!',
  keywords: [
    'pool game',
    '8 pool',
    '8 ball online',
    'pool games online',
    '8 pool ball',
    'online pool games',
    'billiards online',
  ],
  path: PoolClashRoute,
})

export const DunkShotMetaData = generateMetadata({
  title: 'Play Dunk Shot | Best Basketball Game Online',
  description:
    'Play Dunk Shot, a free basketball game online. Enjoy fast-paced shooting action, compete globally, and win real prizes in this top ball game.',
  keywords: [
    'basketball game',
    'basketball shooting game',
    'online basketball games',
    'ball games',
    'basketball games',
    'free basketball game',
  ],
  path: DunkShotRoute,
})

export const DominoesMetaData = generateMetadata({
  title: 'Play Dominoes Online | Best Dominoes Game App & Tile Game',
  description:
    'Play the best dominoes game online! Download the top dominoes game app and enjoy a fun, strategic tile game experience anytime with Avia.',
  keywords: ['dominoes game', 'dominoes game app', 'play dominoes online', 'online dominoes game', 'tile game'],
  path: DominoesRoute,
})
